<template>
  <v-container
    fluid
    class="pt-15 pb-15 fill-height"
  >
    <v-row class="justify-center align-start fill-height">
      <v-col
        sm="11"
        md="10"
        lg="8"
        xl="6"
      >
        <DocumentList
          auto
          inactive
          :check-for-format="FILE_FORMATS.CERTIFICATES"
          :doc-list="certificateList"
          :additional-settings="additionalSettings"
          :loading="loading"
          @input="options = $event"
          @additionalSettingsChange="onAdditionalSettingsChange"
          @deleteClick="onCertificateDelete"
          @deleteAllClick="deleteAll"
          @uploadClick="$refs.inputUpload.click()"
          @dropUpload="uploadMoreFiles"
          @submit="onVerifyFiles"
        />
      </v-col>
    </v-row>
    <input
      v-show="false"
      ref="inputUpload"
      type="file"
      :accept="FILE_FORMATS.CERTIFICATES"
      multiple
      @change="uploadMoreFiles($event.target.files)"
    >
  </v-container>
</template>

<script>
import DocumentList from '@/components/DocumentList'
import { mapActions, mapState } from 'vuex'
import {
  checkFilesForCertificate,
  fileToBase64,
  isArray
} from '@/helpers/helpers'
import { CertificateRequest, VerificationResultCertificate } from '@/helpers/mappers'
import { apiVerifyCertificate } from '@/api/api'
import { STEP, FILE_FORMATS } from '@/helpers/constants'

export default {
  name: 'CertificateOptions',
  components: { DocumentList },

  data () {
    return {
      STEP,
      FILE_FORMATS,
      certificateList: [],
      additionalSettings: [],
      options: [],
      loading: false,
      results: []
    }
  },

  computed: {
    ...mapState({
      certificates: state => state.certificate.files,
      step: state => state.certificate.step,
      chainInclusionHint: state => state.policies.ChainInclusionHint ?? false,
      svsVersion: state => state.policies.Version ?? null
    })
  },

  beforeMount () {
    if (!isArray(this.certificates)) {
      this.changeStep({ type: 'certificate', step: STEP.IDLE })
      this.showError('Не удалось прочитать файлы')
      return
    }
    this.mapFilesIntoList(this.certificates)

    // Дополнительные чекбоксы под списком документов если вторая версия
    if (this.svsVersion === 2) {
      this.additionalSettings.push({
        name: 'IncludeChain',
        label: 'Добавить цепочку сертификата подписи в результат проверки',
        value: this.chainInclusionHint
      })
    }
  },

  methods: {
    ...mapActions(['changeStep', 'saveMoreCertificates', 'deleteCertificate', 'resultDataSave']),
    ...mapActions('notification', ['showAlert', 'showError']),

    mapFilesIntoList (files) {
      if (files.length) {
        this.certificateList = files.map((file, index) => {
          return {
            name: file.name,
            id: index
          }
        })
      } else {
        this.certificateList = []
      }
    },

    onCertificateDelete (id) {
      this.deleteCertificate(id)
      if (!isArray(this.certificates)) {
        this.changeStep({ type: 'certificate', step: STEP.IDLE })
        return
      }
      this.mapFilesIntoList(this.certificates)
    },

    deleteAll () {
      this.deleteCertificate()
      if (!isArray(this.certificates)) {
        this.changeStep({ type: 'certificate', step: STEP.IDLE })
      }
    },

    uploadMoreFiles (files) {
      this.saveMoreCertificates(files)
      checkFilesForCertificate(files)
      this.mapFilesIntoList(this.certificates)
    },

    onAdditionalSettingsChange (newSetting) {
      const thisSetting = this.additionalSettings.find(setting => setting.name === newSetting.name)

      if (thisSetting) {
        thisSetting.value = newSetting.value
      }
    },

    async onVerifyFiles () {
      this.loading = true

      const files = this.certificates
      if (isArray(files)) {
        for (const file of files) {
          const base64Result = await fileToBase64(file)
          const response = await apiVerifyCertificate(new CertificateRequest(base64Result, this.options, this.additionalSettings))
          if (!response?.result) {
            if (response?.errorMsg) {
              this.showError(`Ошибка! ${response?.errorMsg}`)
            }
          } else {
            this.results.push(new VerificationResultCertificate(response, file.name))
          }
        }
      }

      if (this.results.length) {
        this.resultDataSave({ type: 'certificate', data: this.results })
        this.changeStep({ type: 'certificate', step: STEP.RESULT })
      } else {
        this.changeStep({ type: 'certificate', step: STEP.IDLE })
      }

      this.loading = false
    }
  }
}
</script>
